# need this blank service bc credit score dashboard depends on it existing
# see credit-score-dashboard repo for details
class MixpanelService
  constructor: () ->
  $get: ["$q", "$rootScope", ($q, $rootScope) ->
  ]

angular
.module("avant.services")
.provider("MixpanelService", MixpanelService)

if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = MixpanelService
  exports.MixpanelService = MixpanelService
else
  window.MixpanelService = MixpanelService
